;(function() {
  'use strict'

  angular
    .module('glow.reporting')
    .component('glQuestionNumericFilter', Component())

  function Component() {
    return {
      controller: Controller,
      templateUrl: 'numeric-filter.template.html',
      bindings: {
        question: '=',
        filter: '=',
      },
    }
  }

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.toggle = toggle

    function onInit() {
      ctrl.question = _.cloneDeep(ctrl.question)

      if (ctrl.filter.newValue) {
        var choice = _.find(ctrl.question.choices, {
          option: ctrl.filter.newValue,
        })

        // Only add the choice if not already selected/added
        if (
          choice &&
          !_.find(ctrl.filter.data.values, { number: choice.number })
        ) {
          ctrl.filter.data.values.push({ number: choice.number })
        }
        ctrl.filter.newValue = undefined
      }

      _.each(ctrl.filter.data.values, function(choice) {
        var questionChoice = _.find(ctrl.question.choices, {
          number: choice.number,
        })
        if (questionChoice) {
          questionChoice.isSelected = true
        }
      })
    }

    function toggle(choice) {
      if (choice.isSelected) {
        ctrl.filter.data.values.push({ number: choice.number })
      } else {
        _.remove(ctrl.filter.data.values, { number: choice.number })
      }
    }
  }
})()
